import { useDeletePrivateNote } from "../../features/privateNotes/api/useDeletePrivateNote";
import { PrivateNotesDatabase } from "../../types";
import ConfirmDeleteDialog from "../ConfirmDeleteDialog/ConfirmDeleteDialog";

type Props = {
  note: PrivateNotesDatabase;
  onClose: () => void;
  onDeleted?: () => void;
};

export default function DeleteNoteModal(props: Props) {
  const { mutateAsync: deleteNote } = useDeletePrivateNote();

  async function handleDeleteNote() {
    await deleteNote(props.note.id);
    props.onDeleted?.();
  }

  return (
    <ConfirmDeleteDialog
      title="Supprimer la note"
      confirmLabel="Supprimer la note"
      onConfirm={handleDeleteNote}
      onClose={props.onClose}
    >
      Êtes-vous sûr de vouloir supprimer la note « {props.note.title} » ?
    </ConfirmDeleteDialog>
  );
}
